export default "__VITE_ASSET__Rrm_4bOp__";